<div class="report-model detail-info">

    
    <app-datatable-title [title]="'reports.residentialUnits'" [count]="residentialUnitsCount"></app-datatable-title>

    <app-residential-detail-table
        class="default-table-view"
        [tableName]="'residentialUnits'"
        [showLoader]="!residentialUnitsLoading" 
        [tableColumns]="residentialColumns" 
        [dataLength]="residentialDataCount"
        [tableData]="residentialUnitsData" 
        [allowExcelDownload]="true"
        (pageEvent)="onPageEvent($event)" 
        (sort)="sortData($event)"
        (excelDownload)="downloadExcel($event, 'ir_inventory_unit')"
        [downloadLoading]="reportPropertyDetailService.downloadLoading['a']">
    </app-residential-detail-table>

</div>    